import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UsuarioDetalhes} from "../../../models/usuario-detalhes";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {UsuarioService} from "../../../services/usuario-service";
import Swal from "sweetalert2";
import {Token} from "../../../models/token";
import {AuthService} from "../../../services/auth-service";
import {NovaSenha} from "../../../models/nova-senha";

@Component({
    selector: 'app-detalhes',
    templateUrl: './detalhes.component.html',
    styleUrl: './detalhes.component.css',
    standalone: false
})
export class DetalhesComponent {
  token: Token | undefined;
  loading = true;
  usuario = new UsuarioDetalhes();
  novaSenha = new NovaSenha();
  formAlterarDados: FormGroup;
  formAlterarSenha: FormGroup;
  id = 0;
  show = '';
  showAlterarDados = true;
  showAlterarSenha = false;
  showDetalhesConta = false;
  tipo = '';
  tiposUsuario = [
    { id: '0', descricao: 'Administrador' },
    { id: '1', descricao: 'Gestor Administrador' },
    { id: '2', descricao: 'Advogado Administrador' },
    { id: '5', descricao: 'Advogado' },
    { id: '3', descricao: 'Assistente Jurídico' },
    { id: '4', descricao: 'Cliente' }
  ];

  constructor(private router: Router,
              private toastr: ToastrService,
              private formBuilder: FormBuilder,
              private usuarioService: UsuarioService,
              private tokenService: AuthService,
              private route: ActivatedRoute) {
    this.token = this.tokenService.AccessToken;
    this.construirFormulario();
    this.construirFormularioAlterarSenha();
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.show = params['show'];

      if(this.show == undefined || this.show == 'dados')
        this.mostrarAlterarDados();
      else if(this.show == 'senha')
        this.mostrarAlterarSenha();
      else if(this.show == 'info')
        this.mostrarDetalhes();

      this.buscarPorId(this.id);

      this.loading = false;
    });

  }

  voltar(){
    this.router.navigateByUrl('/auth/usuario');
  }

  private buscarPorId(id: number){
    this.usuarioService.buscarPorId(id).subscribe(retorno => {
      if(retorno.sucesso)
      {
        this.usuario = retorno.dados;

        switch (retorno.dados.tipoUsuario) {
          case 0:
            this.tipo = "Administrador";
            break;
          case 1:
            this.tipo = "Gestor Administrador";
            break;
          case 2:
            this.tipo = "Advogado Gestor";
            break
          case 3:
            this.tipo = "Assistente Juridico";
            break;
          case 4:
            this.tipo = "Cliente";
            break;
        }
      }
      this.preencherFormulario();

    });
  }

  private construirFormulario(){
    this.formAlterarDados = this.formBuilder.group({
      nome: [this.usuario.nome, [Validators.required]],
      tipoUsuario: [this.usuario.tipoUsuario, [Validators.required]]
    });
  }

  private construirFormularioAlterarSenha(){
    this.formAlterarSenha = this.formBuilder.group({
      senhaAntiga: [this.novaSenha.senhaAntiga, [Validators.required]],
      senhaNova: [this.novaSenha.novaSenha, [Validators.required]],
      confirmacaoSenha: [this.novaSenha.confirmacaoSenha, [Validators.required]]
    });
  }

  private preencherFormulario(){
    this.formAlterarDados.patchValue({
      nome: this.usuario.nome,
      tipoUsuario: this.usuario.tipoUsuario,
    });
  }
  salvarAlteracoes(){
    Swal.fire({
      title: 'Deseja realmente alterar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.preencherModelo();
        this.usuarioService.alterar(this.usuario).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuario alterado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao alterar o cliente - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao alterar o cliente - " + error);
        });
        this.loading = false;
      }
    });
  }

  alterarSenha(){
    Swal.fire({
      title: 'Deseja realmente alterar a senha?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.preencherModeloAlterarSenha();
        this.usuarioService.alterarSenha(this.novaSenha).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Senha alterada com sucesso");
            this.formAlterarSenha.reset();
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao alterar a senha - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao alterar a senha - " + error);
        });
      }
      });
  }
  gerarSenha(){}

  desativar(){
    Swal.fire({
      title: 'Deseja realmente desativar usuário?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      this.loading = true;
      if(result.value) {
        this.usuarioService.desativar(this.id).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuário desativado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao desativado o usuário - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao desativado o usuário - " + error);
        });
      }
    });
  }

  desbloquear(){
    Swal.fire({
      title: 'Deseja realmente desbloquear o usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      this.loading = true;
      if(result.value) {
        this.usuarioService.desbloquear(this.id).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuário desbloqueado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao desbloquear o usuário - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao desbloquear o usuário - " + error);
        });
      }
    });
  }

  ativar(){
    Swal.fire({
      title: 'Deseja realmente ativar o usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {

      if(result.value) {
        this.loading = true;
        this.usuarioService.ativar(this.id).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Usuário ativado com sucesso");
            this.buscarPorId(this.id);
          } else {
            this.toastr.error("Erro ao ativar o usuário - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao ativar o usuário - " + error);
        });
      }
    });
  }

  preencherModeloAlterarSenha(){
    this.novaSenha.senhaAntiga = this.formAlterarSenha.controls['senhaAntiga'].value;
    this.novaSenha.novaSenha = this.formAlterarSenha.controls['senhaNova'].value;
    this.novaSenha.confirmacaoSenha = this.formAlterarSenha.controls['confirmacaoSenha'].value;
    this.novaSenha.email = this.usuario.email;
  }

  preencherModelo(){
    this.usuario.tipoUsuario = this.formAlterarDados.controls['tipoUsuario'].value;
    this.usuario.nome = this.formAlterarDados.controls['nome'].value;
  }

  mostrarAlterarSenha(){
    this.showAlterarSenha = true;
    this.showDetalhesConta = false;
    this.showAlterarDados = false;
  }

  mostrarAlterarDados(){
    this.showAlterarSenha = false;
    this.showDetalhesConta = false;
    this.showAlterarDados = true;
  }

  mostrarDetalhes(){
    this.showDetalhesConta = true;
    this.showAlterarDados = false;
    this.showAlterarSenha = false;
  }
}
